<svg width="50" height="20">
    <circle cx="8" cy="8" r="8" [attr.fill]="teacher.HexColor" >
        <title>{{getTeacherLabel()}}</title>
    </circle>
    <polygon points="8,0 30,0 20,16 8,16" [attr.fill]="teacher.HexColor">
        <title>{{getTeacherLabel()}}</title>
    </polygon>
    <circle cx="42" cy="8" r="8" [attr.fill]="evaluator.HexColor">
        <title>{{getEvaluatorLabel()}}</title>
    </circle>
    <polygon points="42,0 42,16 15,16 25,0" [attr.fill]="evaluator.HexColor">
        <title>{{getEvaluatorLabel()}}</title>
    </polygon>
    <polygon points="25,-4 15,20" style="stroke:#fff; stroke-width:4" />
</svg>